import { render, staticRenderFns } from "./MyTaskKanban.vue?vue&type=template&id=f25a0128&scoped=true"
import script from "./MyTaskKanban.vue?vue&type=script&lang=js"
export * from "./MyTaskKanban.vue?vue&type=script&lang=js"
import style0 from "./MyTaskKanban.vue?vue&type=style&index=0&id=f25a0128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25a0128",
  null
  
)

export default component.exports